import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import Avatar from '@components/avatar';
import { BASE_IMG_URL } from '@images/imageUrls';
import classNames from 'classnames';
import { formatTime } from '@utils/timeUtils'; // 相对路径
import ThreadImgList from '@components/threadImgList';
import InfiniteScrollList from '@components/InfiniteScrollList';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// 导入 Swiper 样式
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { highlightname } from '@utils/high-light-name';
import { setPostImage } from '@images/imageUrls';
import { formatNumberToWan } from '@utils/formatNumber';

interface PCThreadListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    data: any
    likeClick?: Function
    actionType?: 'like' | 'favorite' // 操作类型：点赞/收藏
    actionClick?: Function // 操作点击事件
    goDetails?: Function
    goUser?: Function
    searchKeyword?: any // 需要高亮的关键字
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式
    emptyExtra?: React.ReactNode; // 空态文案下方的自定义插槽
    isSelf?: boolean    // 是否是作者自己
    showThreadStatus?: any  // 是否显示帖子状态（为个人中心发帖列表加的）
    namespace?: string;
}

@inject('app', 'site')
@observer
class PCThreadList extends React.Component<PCThreadListProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }
    // 渲染单个列表项
    renderThreadItem = (item: any, index: number) => {
        const { likeClick, actionType = 'like', actionClick, goDetails, goUser, searchKeyword, user, showThreadStatus, isSelf } = this.props;
        return (
            <React.Fragment key={item.id || item._id || index}>
                <div className={styles.postItem} key={item.id || item._id}>
                    <div className={styles.postUserBox}>
                        <div className={styles.postUserLeft}>
                            <Avatar
                                avatarUrl={item.thread?.user?.avatar}
                                titleMark={item.thread?.user?.titleMark}
                                userCode={item.thread?.user?.code}
                                size={40}
                                officialSize={16}
                            ></Avatar>
                            <div className={styles.userDetail}>
                                <div
                                    className={styles.userNameBox}
                                    onClick={() => goUser && goUser(item.thread?.user)}
                                >
                                    <div className={styles.userName}>
                                        {item.thread?.user?.nickname || '普通用户'}
                                    </div>
                                    {item.thread?.user?.titleName && (
                                        <div className={styles.titleName}>
                                            {item.thread?.user?.titleName}
                                        </div>
                                    )}
                                </div>
                                <div className={styles.model}>{item.thread?.source}</div>
                            </div>
                        </div>
                        {/* <div className={styles.postUserRight}> */}
                        {/* </div> */}
                    </div>

                    {/* 帖子图片 */}
                    <div
                        className={styles.postImgBox}
                        onClick={() => goDetails && goDetails(item)}
                    >
                        <ThreadImgList
                            cover={item.thread?.cover}
                            isVideo={item.thread?.video ? true : false}
                            videoData={item.thread?.video}
                            imageList={item.thread?.images}
                            maxDisplay={6}
                        ></ThreadImgList>
                    </div>

                    {item.thread?.summary && <div
                        className={styles.postContent}
                        style={{color:  (item.thread?.isHidden || (!item.thread?.isDisplay && user?.userInfo?.group?.isAdmin)) ? '#D1D3D4' : item.thread?.title != '' ? '#6D6E71': 'inherit'}}
                        onClick={() => goDetails && goDetails(item)}
                    >
                        {item.solveState == 0 && <span className={classNames(styles.feedbackStatus, styles.feedbackStatus0)}>未解决</span>}
                        {item.solveState == 1 && <span className={classNames(styles.feedbackStatus, styles.feedbackStatus1)}>待处理</span>}
                        {item.solveState == 2 && <span className={classNames(styles.feedbackStatus, styles.feedbackStatus2)}>已回复</span>}
                        {item.solveState == 3 && <span className={classNames(styles.feedbackStatus, styles.feedbackStatus3)}>已解决</span>}
                        <span dangerouslySetInnerHTML={{ 
                            __html: highlightname(item.thread?.summary, searchKeyword) || '内容'
                        }} />
                    </div>}

                    <div className={styles.postOperaBox}>
                        <div className={styles.postOperaLeft}>
                            {/* 如果有置顶评论，显示置顶评论，没有置顶评论，显示发布时间 */}
                            {(item.thread?.stickyPost) && <div className={styles.stickComment}>
                                <Avatar
                                    avatarUrl={item.thread?.stickyPost?.user?.avatar}
                                    showOfficialTag={false}
                                    size={18}
                                    titleMark={item.thread?.stickyPost?.user?.titleMark}
                                    userCode={item.thread?.stickyPost?.user?.code}
                                ></Avatar>
                                <div className={styles.commentContent}>
                                    {item.thread?.stickyPost.summary}
                                </div>
                            </div>}
                            {(!item.thread?.stickyPost && ((!item.thread?.isHidden || item.thread?.isDisplay))) && <div className={styles.postTime} style={{color: (item.thread?.isHidden || (!item.thread?.isDisplay &&  user?.userInfo?.group?.isAdmin)) ? '#D1D3D4' :''}}>
                                {(() => {
                                    // 判断是否是定时发布且时间未到
                                    if (item.fixedAt) {
                                        const fixedDate = new Date(item.fixedAt).getTime();
                                        const nowDate = new Date().getTime();
                                        // 如果定时发布时间还没到，不显示任何时间信息
                                        if (fixedDate > nowDate) {
                                            return null;
                                        }
                                    }
                                    return formatTime(item.thread?.createdAt);
                                })()}
                            </div>}
                        </div>
                        <div className={styles.operaItemBox}>
                            <div
                                className={styles.operaItem}
                                onClick={() => goDetails && goDetails(item)}
                            >
                                <img
                                    src={`${BASE_IMG_URL}/common/comment.png`}
                                    alt="评论"
                                    className={styles.operaIcon}
                                />
                                <span className={styles.operaCount}>
                                    {item.thread?.postCount == 0 ? '首评' : formatNumberToWan(item.thread?.postCount)}
                                </span>
                            </div>

                            <div
                                className={styles.operaItem}
                                onClick={() => window.globalEnsureLogin(() => (actionClick || likeClick) && (actionClick || likeClick)(item))}
                            >
                                
                                {!item.thread?.isLiked ? (
                                    <img
                                        src={`${BASE_IMG_URL}/common/like.png`}
                                        alt="点赞"
                                        className={styles.operaIcon}
                                    />
                                ) : (
                                    <img
                                        src={`${BASE_IMG_URL}/common/liked.png`}
                                        alt="已点赞"
                                        className={styles.operaIcon}
                                    />
                                )}
                                <span
                                    className={styles.operaCount}
                                    style={{ color: item.thread?.isLiked ? '#980808' : '' }}
                                >
                                    {item.thread?.likeCount == 0 ? '首赞' : formatNumberToWan(item.thread?.likeCount)}
                                </span>
                            </div>
                            
                        </div>
                            
                    </div>
                </div>
            </React.Fragment>
        );
    };

    render() {
        const { data, loading = false, hasMore = true, emptyText, emptyIcon, emptyBoxStyle, emptyExtra, onLoadMore } = this.props;

        if (!Array.isArray(data)) return null;

        return (
            <div className={styles.threadListBox}>
                <InfiniteScrollList
                    variant="pc"
                    data={data}
                    loading={loading}
                    hasMore={hasMore}
                    onLoadMore={onLoadMore || (() => { })}
                    renderItem={this.renderThreadItem}
                    threshold={100}
                    emptyText={emptyText || '这里是空的'}
                    emptyIcon={emptyIcon}
                    emptyBoxStyle={emptyBoxStyle}
                    emptyExtra={emptyExtra}
                    loadingText="加载中..."
                    noMoreText="没有更多帖子了"
                />
            </div>
        );
    }
}

export default PCThreadList;
